import {
  downloadStudentCorrespondenceAttachment,
  downloadFromUrl,
  CorrespondenceThreadSearchSchema,
} from "toptaal-shared"
import { createFileRoute, useParams, useRouter } from "@tanstack/react-router"
import { CorrespondenceChat } from "toptaal-shared"
import ScreenWrapper from "@/components/ScreenWrapper"
import {
  useCorrespondenceSuspenseQuery,
  useCurrentStudentSuspenseQuery,
  useRespondToCorrespondenceMutation,
  useStudentCorrespondenceMessagesInfiniteQuery,
} from "students-api"

export const Route = createFileRoute("/correspondentie/$threadId")({
  component: RouteComponent,
  validateSearch: CorrespondenceThreadSearchSchema,
})

function RouteComponent() {
  const router = useRouter()
  const { data: user } = useCurrentStudentSuspenseQuery()
  const { threadId: threadIdParam } = useParams({
    from: "/correspondentie/$threadId",
  })
  const threadId = Number(threadIdParam)

  const { data: correspondenceThread, isLoading } =
    useCorrespondenceSuspenseQuery(threadId)

  const replyMutation = useRespondToCorrespondenceMutation(threadId)

  const handleDownloadAttachment = async (
    correspondenceId: number,
    attachmentId: number,
    filename: string,
  ) => {
    const {
      data: { url },
    } = await downloadStudentCorrespondenceAttachment({
      correspondenceThreadId: threadId,
      correspondenceId,
      attachmentId,
    })

    downloadFromUrl(url, filename)
  }

  const handleSendMessage = async (message: string, files?: File[]) => {
    await replyMutation.mutateAsync({
      correspondence: {
        content: message,
      },
      files,
    })
  }

  const handleNavigateBack = () => {
    router.navigate({
      to: "/correspondentie",
    })
  }

  const {
    data: infinitePages,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading: isMessagesLoading,
    isSuccess: isMessagesSuccess,
  } = useStudentCorrespondenceMessagesInfiniteQuery({
    threadId,
  })

  return (
    <ScreenWrapper className="!px-0">
      <CorrespondenceChat
        currentUser={user}
        correspondenceThread={correspondenceThread.data}
        messages={infinitePages?.flattenedMessages}
        isMessagesSuccess={isMessagesSuccess}
        isLoadingMore={isFetchingNextPage}
        hasMore={hasNextPage}
        onLoadMore={fetchNextPage}
        isLoading={isLoading || isMessagesLoading}
        onSendMessage={handleSendMessage}
        handleNavigateBack={handleNavigateBack}
        onDownload={handleDownloadAttachment}
        showEditButton={false}
      />
    </ScreenWrapper>
  )
}
